import { ToDto } from "@dotlegal/dotlegal-ui-components";
import DotLegalWarningTriangle from "@common/components/dotLegalWarningTriangle/DotLegalWarningTriangle";
import RiskLevelChip from "./RiskLevelChip";
import { getRiskLevelIndicatorChipStyle, RiskLevelIndicator } from "../riskSettings/riskArea/riskAreaDialog/riskLevels/riskLevelIndicators";

export interface IIndicatorRiskChip {
    level: number;
    label: string;
    riskLevelIndicators: Array<RiskLevelIndicator>;
    eliminated?: boolean;
    linkTo?: ToDto | string;
    // The over-appetite warning belongs to the chip, not beside it: a level with no configured indicator renders
    // nothing at all, and a lone triangle would then assert a risk the reader cannot see.
    overAppetiteWarningText?: string;
}

// A risk-level chip coloured from the area's configured level indicators, so any surface (overview tables, the
// entity top bar) renders a level the same way. Returns null when the level has no configured indicator.
function IndicatorRiskChip({ level, label, riskLevelIndicators, eliminated = false, linkTo, overAppetiteWarningText }: IIndicatorRiskChip) {
    const style = getRiskLevelIndicatorChipStyle(level, riskLevelIndicators);

    if (!style) return null;

    return (
        <>
            <RiskLevelChip level={level} label={label} color={style.color} icon={style.icon} eliminated={eliminated} linkTo={linkTo} />
            {overAppetiteWarningText !== undefined && <DotLegalWarningTriangle warningText={overAppetiteWarningText} />}
        </>
    );
}

export default IndicatorRiskChip;
